<div class="card text-center" style="border: none; height: 200px">
  <div
    class="card modal-body"
    style="display: flex; justify-content: space-evenly; font-size: 1.7em"
  >
    <div class="row" *ngIf="erro">
      <div class="col-md-12" style="margin-top: 10px">
        <div class="alert alert-danger" role="alert">
          Selecione uma cidade para confirmar
        </div>
      </div>
    </div>
    Selecione uma cidade para continuar
    <div class="row">
      <div class="col-md-3"></div>
      <div class="form-group col-md-6">
        <select class="form-select" [(ngModel)]="cidade">
          <option [ngValue]="null">Selecione...</option>
          <option *ngFor="let item of cidades" [value]="item.cidade">
            {{ item.cidade }}
          </option>
        </select>
      </div>
      <div class="col-md-3"></div>

      <div class="col-md-12 mt-3">
        <button class="btn btn-primary" (click)="selecionar()">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>
